<template>
    <div id="upgrade-modal" class="upgrade-modal modal" v-bind:class="{ show: showUpgradeModal, 'ui-light-theme' : lightTheme }" tabindex="-1" role="dialog" aria-modal="true" v-if="showUpgradeModal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Modify Plan</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click.prevent="closeUpgradeModal()">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body modal-body-padding">

                    <form method="POST" v-if="!upgradeSuccessful">
                                                
                        <div class="row">
                            <div class="col-md-6">                                        
                                
                                <div class="form-group">
                                    <label class="sr-only">Company Plan</label>
                                    <select name="period" class="form-control" v-model="chosenPlan">
                                        <option value="planb10">Company: Up to 40 Employees</option>
                                        <option value="planb20">Company: Up to 100 Employees</option>
                                        <option value="planb30">Company: Up to 250 Employees</option>
                                        <option value="planb35" v-if="plans.hasOwnProperty('planb35')">Company: Up to 500 Employees</option>
                                        <option value="planb45" v-if="plans.hasOwnProperty('planb45')">Company: Up to 750 Employees</option>
                                        <option value="planb32" v-if="plans.hasOwnProperty('planb32')">Company: Up to 500 Employees</option>
                                        <option value="planb42" v-if="plans.hasOwnProperty('planb42')">Company: Up to 750 Employees</option>
                                    </select>
                                    <span class="invalid-feedback show-invalid" role="alert" v-if="this.upgradeErrors && this.upgradeErrors.hasOwnProperty('plan')">
                                        <strong v-text="this.upgradeErrors.plan[0]"></strong>
                                    </span>
                                </div>
                                <div class="form-group" v-if="monthlyIsAvailable()">
                                    <label class="sr-only">Period</label>
                                    <select name="period" class="form-control" v-model="monthly">
                                        <option v-bind:value="true">Pay Monthly</option>
                                        <option v-bind:value="false">Pay Yearly ({{ chosenPlanSavings }})</option>
                                    </select>
                                    <span class="invalid-feedback show-invalid" role="alert" v-if="this.upgradeErrors && this.upgradeErrors.hasOwnProperty('period')">
                                        <strong v-text="this.upgradeErrors.period[0]"></strong>
                                    </span>
                                </div>
                                <div class="form-group" v-if="!organization.name">
                                    <label class="sr-only">Company Name</label>
                                    <input type="text" name="organization" class="form-control" placeholder="Company Name" v-model="upgradeOrganizationName">
                                    <span class="invalid-feedback show-invalid" role="alert" v-if="this.upgradeErrors && this.upgradeErrors.hasOwnProperty('organization')">
                                        <strong v-text="this.upgradeErrors.organization[0]"></strong>
                                    </span>
                                </div>
                                <div class="invalid-feedback show-invalid" role="alert" v-if="this.upgradeErrors && this.upgradeErrors.hasOwnProperty('upgrade_issue')">
                                    <strong v-text="this.upgradeErrors.upgrade_issue[0]"></strong>
                                </div>
                            </div><!-- .col-md-6 -->
                            <div class="col-md-6 d-none d-md-block">
                                <h3 class="plan-details-price" v-html="priceText"></h3>
                                <div class="plan-details text-center">
                                    <ul class="pricing-list list-unstyled m-0">
                                        <li><strong>Up to {{ chosenPlanEmployees }}</strong> Employees</li>
                                        <li><strong>{{ chosenPlanBaseSigs }} Templated</strong> Signature Designs</li>
                                        <li><strong>Unlimited</strong> Fields &amp; Images</li>
                                        <li>Premium Templates</li>
                                        <li>Premium Fields & Features</li>
                                        <li>Premium Icons</li>
                                        <li>Custom Icon Colors</li>
                                        <li>Signature Generator Links</li>
                                        <li>Saved Employee Signatures</li>
                                        <li>Send Signatures via Email</li>
                                        <li>Admin Email Support</li>
                                    </ul>
                                </div><!-- .plan-details -->
                            </div><!-- .col-md-6 -->
                        </div><!-- .row -->

                        <div class="text-center mt-3">
                            <button class="btn btn-primary btn-block" v-on:click.prevent="upgrade()" v-bind:disabled="upgradeDisabled" v-html="upgradeButtonText"></button>
                            <div class="mt-2">Any unused time on your account will be prorated to your new plan.</div>
                        </div><!-- .text-center -->

                    </form>

                    <div class="purchase-successful" v-if="upgradeSuccessful">
                        <div class="alert alert-success">Your upgrade was successful. Thanks for your business!</div>
                        <div class="text-center">
                            <button class="btn btn-primary" v-on:click.prevent="closeUpgradeModal()">Close & Continue</button>
                        </div>
                    </div><!-- .purchase-successful -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            showUpgradeModal: {
                type: Boolean,
                default: false,
            },
            theme: {
                type: String,
                default: 'dark'
            },
            user: {
                type: Object,
                default: null,
            },
            organization: {
                type: Object,
                default: null,
            }
        },
        data: function () {
            return {
                upgradeLoading: false,
                upgradeSuccessful: false,
                currentPlan: '',
                chosenPlan: 'planb10',
                monthly: true,
                upgradeOrganizationName: '',
                upgradeErrors: null,
                soloplancost: 19,
                plans: {
                    planb10: {
                        yearly: 199,
                        monthly: 19,
                        templates: 5,
                        employees: 40,
                    },
                    planb20: {
                        yearly: 399,
                        monthly: 39,
                        templates: 10,
                        employees: 100,
                    },
                    planb30: {
                        yearly: 599,
                        monthly: 59,
                        templates: 15,
                        employees: 250,
                    },
                },
                oldPlan2: {
                    name: 'plan2',
                    yearly: 399,
                    monthly: 39,
                    templates: 2,
                    employees: 10,
                },
                sale: {
                    active: false,
                    plan1yearly: 0,
                    plan2yearly: 0,
                }
            }
        },
        mounted() {
            if (this.organization) {
                if (this.organization.period == 'yearly' ) {
                    this.monthly = false;
                } else {
                    this.monthly = true;
                }
                this.currentPlan = this.organization.plan_name;
                if (this.organization.plan_name == 'solo') {
                    this.chosenPlan = 'planb10';
                } else if (this.organization.plan_name == 'planb10') {
                    this.chosenPlan = 'planb20';
                } else if (this.organization.plan_name == 'planb20') {
                    this.chosenPlan = 'planb30';
                } else if (this.organization.plan_name == 'planb30') {
                    this.plans.planb35 = {
                        yearly: 999,
                        monthly: 99,
                        templates: 25,
                        employees: 500,
                    };
                    this.chosenPlan = 'planb35';
                } else if (this.organization.plan_name == 'planb35') {
                    this.plans.planb35 = {
                        yearly: 999,
                        monthly: 99,
                        templates: 25,
                        employees: 500,
                    };
                    this.plans.planb45 = {
                        yearly: 1499,
                        monthly: 149,
                        templates: 35,
                        employees: 750,
                    };
                    this.chosenPlan = 'planb45';
                } else if (this.organization.plan_name == 'planb45') {
                    this.plans.planb35 = {
                        yearly: 999,
                        monthly: 99,
                        templates: 25,
                        employees: 500,
                    };
                    this.plans.planb45 = {
                        yearly: 1499,
                        monthly: 149,
                        templates: 35,
                        employees: 750,
                    };
                    this.chosenPlan = 'planb45';
                } else if (this.organization.plan_name == 'newplan1') {
                    this.chosenPlan = 'planb10';
                } else if (this.organization.plan_name == 'newplan2') {
                    this.chosenPlan = 'planb10';
                } else if (this.organization.plan_name == 'newplan3') {
                    this.chosenPlan = 'planb20';
                } else if (this.organization.plan_name == 'plan1') {
                    this.plans.planb32 = {
                        yearly: 499,
                        monthly: 49,
                        templates: 25,
                        employees: 500,
                    };
                    this.chosenPlan = 'planb32';
                } else if (this.organization.plan_name == 'plan2') {
                    this.plans.planb32 = {
                        yearly: 499,
                        monthly: 49,
                        templates: 25,
                        employees: 500,
                    };
                    this.plans.planb42 = {
                        yearly: 699,
                        monthly: 69,
                        templates: 35,
                        employees: 750,
                    };
                    this.chosenPlan = 'planb42';
                } else {
                    this.chosenPlan = this.organization.plan_name;
                }
                // if (this.organization.plan_name == 'solo') {
                //     this.chosenPlan = 'plan1';
                //     this.purchasePeriod = 'yearly';
                //     if (this.sale.active) {
                //         this.prices.plan1.yearly = this.prices.plan1.yearly + this.sale.plan1yearly;
                //         this.prices.plan2.yearly = this.prices.plan2.yearly + this.sale.plan2yearly;
                //     }
                // } else {
                //     if (this.organization.plan_name == 'plan1') {
                //         this.chosenPlan = 'plan2';
                //     } else {
                //         this.chosenPlan = 'plan2';
                //     }
                //     if (this.organization.period == 'yearly' ) {
                //         this.purchasePeriod = 'yearly';
                //     } else {
                //         this.purchasePeriod = 'monthly';
                //     }
                // }

                //  else if (this.organization.plan_name == 'plan2') {
                //     this.chosenPlan = 'plan3';
                // } else if (this.organization.plan_name == 'plan3') {
                //     this.chosenPlan = 'plan4';
                // }
                
            }
        },
        computed: {
            chosenPlanBaseSigs: function() {
                if (this.chosenPlan && this.plans.hasOwnProperty(this.chosenPlan)) {
                    return this.plans[this.chosenPlan].templates;
                } else {
                   return '';
                }
            },
            chosenPlanEmployees: function() {
                if (this.chosenPlan && this.plans.hasOwnProperty(this.chosenPlan)) {
                    return this.plans[this.chosenPlan].employees;
                } else {
                   return '';
                }
            },
            chosenPlanSavings: function() {
                if (this.chosenPlan && this.plans.hasOwnProperty(this.chosenPlan)) {
                    if (this.sale.active) {
                        return "Save $" + ((this.plans[this.chosenPlan].monthly * 12) - (this.plans[this.chosenPlan].yearly + this.sale.plan1yearly)) + ' paid yearly!';
                    } else {
                        return "Save $" + ((this.plans[this.chosenPlan].monthly * 12) - this.plans[this.chosenPlan].yearly) + ' paid yearly';
                    }
                } else {
                    return '';
                }
            },
            upgradeButtonText: function() {
                if (this.upgradeLoading) {
                    return "Please wait... <img src='/img/spinner-white.gif' width='30' height='30'>";
                } else {
                    if (this.plans[this.chosenPlan].employees < this.organization.allowed_employees && this.organization.employees_count > this.plans[this.chosenPlan].employees) {
                        return "Fewer employees than your usage";
                    } else if (this.plans[this.chosenPlan].employees < this.organization.allowed_employees && this.organization.signatures_count > this.plans[this.chosenPlan].templates) {
                        return "Fewer signatures than your usage";
                    } else if (this.chosenPlan === this.currentPlan && this.monthly === false && this.organization.period == 'monthly') {
                        var price = this.chosenPlanPrice(false);
                        return "Switch to yearly billing at $" + price + "/year";
                    } else if (this.chosenPlan === this.currentPlan) {
                        return "Current Plan";
                    } else if (this.plans[this.chosenPlan].employees > this.organization.allowed_employees) {
                        var price = this.chosenPlanPrice(false);
                        if (this.organization.discount) {
                            if (this.organization.discount.percentage) {
                                price = Math.round((price - ((this.organization.discount.amount/100) * price)) * 100) / 100;
                            } else {
                                price = price - this.organization.discount.amount;
                            }
                        }
                        price = price.toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits: 2, maximumFractionDigits: 2});
                        price = price.replace('.00', '');
                        if (this.monthly) {
                            return "Upgrade to " + price + "/month";
                        } else {
                            return "Upgrade to " + price + "/year";
                        }
                    } else if (this.plans[this.chosenPlan].employees < this.organization.allowed_employees) {
                        var price = this.chosenPlanPrice(false);
                        if (this.organization.discount) {
                            if (this.organization.discount.percentage) {
                                price = Math.round((price - ((this.organization.discount.amount/100) * price)) * 100) / 100;
                            } else {
                                price = price - this.organization.discount.amount;
                            }
                        }
                        price = price.toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits: 2, maximumFractionDigits: 2});
                        price = price.replace('.00', '');
                        if (this.monthly) {
                            return "Downgrade to " + price + "/month";
                        } else {
                            return "Downgrade to " + price + "/year";
                        }
                    }
                }
            },
            // shouldDisplayProrateMessage: function() {
            //     if (this.chosenPlan === this.currentPlan && this.monthly === false && this.organization.period == 'monthly') {
            //         return false;
            //     } else if (this.organization.plan_name === 'solo') {
            //         return false;
            //     } else {
            //         return true;
            //     }
            // },
            upgradeDisabled() {
                if (this.plans[this.chosenPlan].employees < this.organization.allowed_employees && this.organization.employees_count > this.plans[this.chosenPlan].employees) {
                    return true;
                } else if (this.plans[this.chosenPlan].employees < this.organization.allowed_employees && this.organization.signatures_count > this.plans[this.chosenPlan].templates) {
                    return true;
                } else if (this.chosenPlan === this.currentPlan && this.organization.period == 'monthly' && this.monthly === true) {
                    return true;
                } else if (this.chosenPlan === this.currentPlan && this.organization.period == 'yearly' && this.monthly === false) {
                    return true;
                } else if (this.upgradeLoading === true) {
                    return true;
                } else {
                    return false;
                }
            },
            lightTheme: function() {
                if (this.theme == 'light') {
                    return true;
                } else {
                    return false;
                }
            },
            priceText: function() {
                if (this.chosenPlan) {
                    if (this.chosenPlan === 'solo') {
                        if (this.sale.active && this.organization.plan_name == 'solo') {
                            var normalPrice = this.prices.solo - this.sale.solo;
                            return "<strike>$" + normalPrice + "</strike> $" + this.prices.solo + " One Time";
                        } else {
                            return "$" + this.prices.solo + " One Time";
                        }
                    } else {
                        var price = this.chosenPlanPrice(false);
                        if (this.monthly) {
                            return "$" + price + "/month";
                        } else {
                            if (this.sale.active && this.organization.plan_name == 'solo') {
                                var normalPrice = null;
                                // if (this.chosenPlan == 'plan1') {
                                //     normalPrice = price - this.sale.plan1yearly;
                                // } else if (this.chosenPlan == 'plan2') {
                                //     normalPrice = price - this.sale.plan2yearly;
                                // }
                                //return "<strike>$" + normalPrice + "</strike> $" + price + "/year";
                            } else {
                                return "$" + price + "/year";
                            }
                        }
                    }
                }
            },
        },
        methods: {
            chosenPlanPrice: function(withDollarSymbol = true) {
                if (this.chosenPlan && this.plans.hasOwnProperty(this.chosenPlan)) {
                    var price = 0;
                    if (this.monthly) {
                        price = this.plans[this.chosenPlan].monthly;
                    } else {
                        price = this.plans[this.chosenPlan].yearly;
                    }
                    if (withDollarSymbol) {
                        price = "$" + price;
                    }
                    return price;
                } else {
                    return '';
                }
            },
            // checkPeriod: function() {
            //     if (this.organization.plan_name == 'plan1') {
            //         this.purchasePeriod = 'yearly';
            //     }
            // },
            monthlyIsAvailable: function() {
                if (this.organization.plan_name !== 'solo' && this.organization.period == 'yearly') {
                    return false;
                } else {
                    return true;
                }
            },
            // pricingPlanSavings: function() {
            //     return "$" + ((this.prices[this.chosenPlan].monthly * 12) - this.prices[this.chosenPlan].yearly);
            // },
            closeUpgradeModal() {
                this.$emit('closeupgrademodal');
            },
            // checkChosenPlan: function() {
            //     if (this.chosenPlan == 'solo') {
            //         this.purchasePeriod = 'Yearly';
            //     }
            // },
            upgrade: function () {
                var self = this;
                self.upgradeLoading = true;
                var object_to_send = {user_id: self.user.id, organization_id: self.organization.id, organization: self.upgradeOrganizationName, plan: this.chosenPlan, monthly: self.monthly};
                axios.post('/generator/upgrade', object_to_send)
                .then(function (response) {
                    //console.log(response);
                    self.upgradeSuccessful = true;
                    self.upgradeLoading = false;
                    self.$emit('upgradesuccessful', response.data.plan_name, response.data.period, response.data.templates, response.data.allowed_employees, response.data.sharing, response.data.monthly_cost, response.data.yearly_cost);
                })
                .catch(function (error) {
                    self.upgradeLoading = false;
                    if (error.response.data.errors) {
                        self.upgradeErrors = error.response.data.errors;
                    } else {
                        console.log(error);
                        console.log(error.response);
                    }
                });
            }
        }
    }
</script>
